const c = module.exports = {
  METHODS: [
    'init', 'destroy', 'push', 'pop',
    'decode', 'decodeNAL', 'encode', 'jpeg', 'jpeg2000', 'y', 'yuv420p', 'yuv444p', 'rgb', 'rgba',
    'frameinfo', 'resize', 'filter', 'destroyFilter', 'destroyFilters',
    'sobelMaskMatrix', 'sobelMaskPixels', 'sobelMask', 'sobelClusters',
    'findPlates', 'setupLimits', 'uniformGray',
  ],
  CODEC: { NONE: 0, JPEG: 7, RAW: 13, H264: 27, PNG: 61, PPM: 62, PBM: 63, PGM: 64, PGMYUV: 65, BMP: 78, JPEG2000: 88, GIF: 97, WEBP: 171, HEVC: 173, H265: 173, YUV4: 32776 },
  PIXEL_FORMAT: Object.fromEntries(['NONE', 'YUV420P', 'YUYV422', 'RGB24', 'BGR24', 'YUV422P', 'YUV444P', 'YUV410P', 'YUV411P', 'GRAY8', 'MONOWHITE', 'MONOBLACK', 'PAL8', 'YUVJ420P', 'YUVJ422P', 'YUVJ444P', 'UYVY422', 'UYYVYY411', 'BGR8', 'BGR4', 'BGR4_BYTE', 'RGB8', 'RGB4', 'RGB4_BYTE', 'NV12', 'NV21', 'ARGB', 'RGBA', 'ABGR', 'BGRA', 'GRAY16BE', 'GRAY16LE', 'YUV440P', 'YUVJ440P'].map((v, i)=>[v, i-1])),
  PICTURE_TYPE: Object.fromEntries(['NONE', 'I', 'P', 'B', 'S', 'SI', 'SP', 'BI'].map((v, i)=>[v, i])),
  COLOR_RANGE: Object.fromEntries(['NONE', 'MPEG', 'JPEG', 'NB'].map((v, i)=>[v, i])),
  COLOR_SPACE: Object.fromEntries(['NONE', 'RGB', 'BT709', 'UNSPECIFIED', 'RESERVED', 'FCC', 'BT470BG', 'SMPTE170M', 'SMPTE240M', 'YCOCG', 'BT2020_NCL', 'BT2020_CL', 'AVCOL_SPC_SMPTE2085', 'AVCOL_SPC_CHROMA_DERIVED_NCL', 'AVCOL_SPC_CHROMA_DERIVED_CL', 'AVCOL_SPC_ICTCP', 'NB'].map((v, i)=>[v, i-1])),
  RESIZE_ALGORITHM: {
    // 4K->1920, 4K->1280
    SWS_FAST_BILINEAR: 1, // 39ms, 11 ms
    SWS_BILINEAR: 2, // 98 ms, 70 ms
    SWS_BICUBIC: 4, // 157 ms, 130 ms
    SWS_X: 8, // 102 ms, 74 ms
    SWS_POINT: 0x10, // 30 ms, 23 ms
    SWS_AREA: 0x20, // 70 ms, 50 ms
    SWS_BICUBLIN: 0x40, // 142 ms, 108 ms
    SWS_GAUSS: 0x80, // 130 ms, 128 ms
    SWS_SINC: 0x100, // 630 ms, 618 ms
    SWS_LANCZOS: 0x200, // 216 ms, 189 ms
    SWS_SPLINE: 0x400, // 335 ms, 312 ms
  },
  DIRECTION_MASK: {
    TOP: 1,
    BOTTOM: 2,
    LEFT: 4,
    RIGHT: 8,
  },
  DIRECTION_HORIZONTAL: (x)=>((x&1) || (x&2)),
  DIRECTION_VERTICAL: (x)=>((x&4) || (x&8)),
  LOG_LEVEL: {
    QUIET: -8,
    PANIC: 0,
    ERROR: 16,
    WARNING: 24,
    INFO: 32,
    VERBOSE: 40,
    DEBUG: 48,
    TRACE: 56,
  },
  ANNEX_B: new Uint8Array([0, 0, 0, 1]),
}

const ERRORS = {
  NO_ERR: 0,
  ERR_INVALID_DECODER_ID: -1,
  ERR_MEM_ALLOC: -2,
  ERR_CODEC_NOT_FOUND: -3,
  ERR_CODEC_NOT_OPEN: -4,
  ERR_DECODER_MISSING: -5,
  ERR_SEND_PACKET: -6,
  ERR_RECEIVE_FRAME: -7,
  ERR_NO_FRAME: -8,
  ERR_PIXEL_FORMAT: -9,
  ERR_SEND_FRAME: -10,
  ERR_RECEIVE_PACKET: -11,
  ERR_FILTER_ID: -12,
  ERR_FILTER_DEFINITION: -13,
  ERR_FILTER_BUFFERSRC: -14,
  ERR_FILTER_BUFFERSINK: -15,
  ERR_FILTER_IN: -16,
  ERR_FILTER_OUT: -17,
  ERR_FILTER_OUT_FORMATS: -18,
  ERR_FILTER_CONFIG: -19,
  ERR_FILTER_INPUT: -20,
  ERR_FILTER_OUTPUT: -21,
  ERR_UNSUPPORTED_PIXEL_FORMAT: -22,
  ERR_INVALID_PARAM: -23,
}
c.ERRORS = Object.fromEntries(Object.entries(ERRORS).map(([k, v])=>[v, k]))
